// Note, this doesn't work right now, pending response on:
// https://github.com/microsoft/fluentui/issues/5322
/**
 * Style override for the Fluent `Card`.
 */
export const cardStyles = theme => ({
    root: {
    //background: theme?.semanticColors.bodyBackground,
    },
});
